/*
 * @Author: LZT
 * @Date: 2023-02-20 16:31:04
 * @LastEditors: LZT
 * @Description:
 * @FilePath: \qs\src\stores\user.js
 */
import { defineStore } from "pinia";
const useRefreshStore = defineStore("refresh", {
  state: () => ({
    pageRefreshData: false // 登录弹窗完成登录之后 是否需要重新请求页面数据 true是
  }),
  actions: {
    // 设置 是否需要重新刷新数据
    setPageRefreshData (pageRefresh) {
      this.pageRefreshData = pageRefresh;
    }
  },
  // 所有数据持久化
  // persist: true,
  // 持久化存储插件其他配置
  // persist: {
  //   debug: true,
  //   // 修改存储中使用的键名称，默认为当前 Store的 id
  //   key: "SET_REFRESH",
  //   // 修改为 sessionStorage，默认为 localStorage
  //   storage: localStorage,
  //   // 部分持久化状态的点符号路径数组，[]意味着没有状态被持久化(默认为undefined，持久化整个状态)
  //   paths: ["pageRefreshData"]
  // }
});
export default useRefreshStore;
